<div class="flex gap-2 overflow-x-auto pb-2 no-scrollbar">
  @for (action of actions; track action) {
  <div (click)="sendQuickMessage(action)" [class]="selectedAction === action
    ? 'bg-[#DDB9FD] border border-[#DDB9FD] hover:bg-white/80'
    : 'bg-white border border-[#DDB9FD] hover:bg-[#DDB9FD]/50 hover:border-[#DDB9FD] hover:border-1'"
    class="rounded-full p-px transition-colors cursor-pointer">

    <button
      class="bg-transparent rounded-full px-4 py-2 text-sm font-medium text-gray-700 whitespace-nowrap transition-colors">
      {{ action.display }}
    </button>
  </div>
  }
</div>